import { render } from "./UsageDetails.vue?vue&type=template&id=79db7950&scoped=true"
import script from "./UsageDetails.vue?vue&type=script&lang=js"
export * from "./UsageDetails.vue?vue&type=script&lang=js"

import "@/styles/pages/usage-details.scss?vue&type=style&index=0&id=79db7950&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79db7950"]])

export default __exports__